<template>
  <div class="section section--member" id="myPage">
    <div class="menu">
      <div class="column">
        <div class="columns is-align-items-center">
          <div class="column header">マイページ</div>
        </div>
        <div class="sectionwrap top">
          <div class="columns is-align-items-center" @click="setMenu('profile')">
            <div class="column" :class="menu == 'profile' ? 'selectedMenu' : ''">プロフィール</div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center" @click="setMenu('payment')">
            <div class="column" :class="menu == 'payment' ? 'selectedMenu' : ''">支払い情報管理</div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center" @click="setMenu('doronPurchase')">
            <div class="column" :class="menu == 'doronPurchase' ? 'selectedMenu' : ''">ゴールド購入</div>
          </div>
        </div>

        <div v-if="idProviderHasPassword" class="sectionwrap" @click="setMenu('profilePasswordReset')">
          <div class="columns is-align-items-center">
            <div class="column" :class="menu == 'profilePasswordReset' ? 'selectedMenu' : ''">パスワード再設定</div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center" @click="setMenu('reserveManager')">
            <div class="column" :class="menu == 'reserveManager' ? 'selectedMenu' : ''">限定配信予約管理</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <component v-bind:is="currentPage" :values="values"></component>
    </div>
  </div>
</template>

<script>
import Profile from '@/pages/Profile';
import Payment from '@/pages/Payment';
import DoronPurchase from '@/pages/DoronPurchase';
import ProfilePasswordReset from '@/pages/ProfilePasswordReset';
import ReserveManager from '@/pages/ReserveManager';


export default {
  name: 'MyPage',
  props: {
    menu: { type: String, default: "profile" },
  },
  components: {
    Profile,
    Payment,
    DoronPurchase,
    ProfilePasswordReset,
    ReserveManager
  },
  data() {
    return {
      values: {},
      menus: {
        "profile": Profile,
        "payment": Payment,
        "doronPurchase": DoronPurchase,
        "profilePasswordReset": ProfilePasswordReset,
        "reserveManager": ReserveManager
      }
    };
  },
  computed: {
    currentPage() {
      return this.menus[this.menu];
    },
    idProviderHasPassword() {
      return this.$store.state.auth.idProviders.includes('password');
    }
  },
  methods: {
    setMenu(menuName) {
      if (this.menus[menuName]) {
        this.$router.push('/mypage/' + menuName);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/mypage.scss';
</style>
